import '../components/burger-menu';
import '../components/mega-menu';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import BurgerMenu from '../components/burger-menu';
import MiniCart from '../components/MiniCart/MiniCart';
import { load } from '@shopify/theme-sections';
load('*');
BurgerMenu.init();
// Mini Cart
const miniCartDom = document.getElementById('header-cart');
if (miniCartDom) {
    ReactDOM.render(React.createElement(MiniCart, {
        locale_title: dataJs.minicart.title,
        locale_empty: dataJs.minicart.empty,
        locale_quantity: dataJs.minicart.quantity,
        locale_continue: dataJs.minicart.continue,
        locale_checkout: dataJs.minicart.checkout,
        locale_cart: dataJs.minicart.cart,
    }), miniCartDom);
}
